import { render } from "./ShowTraining.vue?vue&type=template&id=2ae00918&scoped=true"
import script from "./ShowTraining.vue?vue&type=script&lang=js"
export * from "./ShowTraining.vue?vue&type=script&lang=js"

import "./ShowTraining.vue?vue&type=style&index=0&id=2ae00918&scoped=true&lang=css"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae00918"]])

export default __exports__